module.exports = __webpack_public_path__ + "136d3964a85ef99dae3194dfc8be9e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/Z@2x.png
// module id = 851
// module chunks = 0